
<div class="modal-header">
    <h4 class="modal-title">{{ action }} File</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss(null)"></button>
</div>
<div class="modal-body">
    <div class="mb-3">
        <label for="fileName" class="form-label">File name</label>
        <input type="text" class="form-control" id="fileName" [(ngModel)]="fileName">
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close(fileName)">{{ action }}</button>
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close(null)">Cancel</button>
</div>